import { FC, useEffect } from 'react'

import { useIntersectionObserver } from 'usehooks-ts'

import { useConversationsQuery } from 'api/conversations/queries'

import { useDebouncedSearchValue } from 'hooks/useDebouncedSearchValue'
import { useTranslation } from 'services/i18n'

export const ConversationPagination: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'conversation_history',
  })

  const [ref, isIntersecting] = useIntersectionObserver()

  const debouncedSearchValue = useDebouncedSearchValue()

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetching,
  } = useConversationsQuery({
    query: debouncedSearchValue,
    enabled: false,
  })

  const pagination = data?.pages[data.pages.length - 1].pagination
  const hasPages = pagination?.pages && pagination.pages > 1

  useEffect(() => {
    if (isFetching) return
    if (isIntersecting && hasNextPage) fetchNextPage()
  }, [fetchNextPage, hasNextPage, isIntersecting, isFetching])

  if (!hasPages) return null

  return (
    <>
      {!hasNextPage && (
        <>
          <div className="mx-2 mb-5 mt-2 w-full border-b border-light" />
          <div className="px-2 text-xs font-medium text-subdued">{t('no_more_conversations')}</div>
        </>
      )}
      {hasNextPage && (
        <div ref={ref} />
      )}
    </>
  )
}
